export default __webpack_public_path__ + "static/pic7-a9ca7e471c517fcad9540069b020aceb.jpeg";